import UserType from '@/modules/user-type/pages/user-type/user-types.page.vue';
import UserTypeRegister from '@/modules/user-type/pages/user-type-register/user-types-register.page.vue';

declare const process: any;

export const USER_TYPE_ACCESS_ROUTES = Object.freeze({
    USER_TYPE: 'user-types-route',
    USER_TYPE_REGISTER: 'user-types-register',
});

export const userTypesRoutes = [
    {
        path: `${process.env.BASE_URL}user-type`,
        component: () => import('@/layout/default.layout.vue'),
        children: [
            {
                path: '',
                // name: USER_TYPE_ACCESS_ROUTES.USER_TYPE,
                component: UserType,
                meta: {
                    requiresAuth: true,
                },
                children: [
                    {
                        path: '',
                        // name: USER_TYPE_ACCESS_ROUTES.USER_TYPE_REGISTER,
                        component: UserTypeRegister,
                    },
                ],
            },
        ],
    },
];
